import {
  fetchSubscriptionAuxEligiblePlans,
  fetchSubscriptionAuxPlansGuest,
} from '@/features/account/services/SubscriptionAux/fetchers'
import { type AuxMembershipPlan } from '@/features/account/services/SubscriptionAux/types'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { minutesToMilliseconds } from 'date-fns'
import { useCallback } from 'react'

const SubscriptionPlansQuery = 'SubscriptionAuxPlans'
const SubscriptionPlansGuestQuery = 'SubscriptionAuxPlansGuest'

export const subscriptionPlansQueryOptions = queryOptions({
  queryKey: [SubscriptionPlansQuery] as const,
  queryFn: fetchSubscriptionAuxEligiblePlans,
  staleTime: minutesToMilliseconds(15),
})

export const useQuerySubscriptionPlans = ({
  planType,
  enabled = true,
}: {
  planType?: 'upgrade' | 'downgrade'
  enabled?: boolean
} = {}) => {
  const { userId } = useSession()

  const filterUpgradeDowngradePlans = useCallback(
    (data: AuxMembershipPlan[]) =>
      planType ? data.filter((plan) => plan.plan_type === planType) : data,
    [planType],
  )

  return useQuery({
    ...subscriptionPlansQueryOptions,
    select: filterUpgradeDowngradePlans,
    enabled: Boolean(userId) && enabled,
  })
}

export const subscriptionPlansGuestQueryOptions = queryOptions({
  queryKey: [SubscriptionPlansGuestQuery] as const,
  queryFn: fetchSubscriptionAuxPlansGuest,
})

export const useQuerySubscriptionPlansGuest = () => {
  return useQuery(subscriptionPlansGuestQueryOptions)
}
